import React from "react";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";

const SectionItemPaymentsConfiguration = ({ t, history, column, item }) => {
    return (
        <div className={classNames("sectionItemPaymentsConfiguration")}>
            <ColumnTitleWithIcon column={column} item={item}/>
            <div className={classNames("info")}>
                <div className={classNames("url", "inline")}>
                    <span>*&nbsp;{t("settings.paymeWallet.CREDIT_ACCEPT_READY")}:&nbsp;</span>
                    {item.paymeWalletSignupUrl && (
                        <a href={item.paymeWalletSignupUrl}>{item.paymeWalletSignupUrl}</a>                                                      
                    )}
                    {!item.paymeWalletSignupUrl && (<span>{t("settings.paymeWallet.PAYME_WALLET_SIGNUO_URL")}</span>)}
                </div>                    
            </div>
        </div>
    );
}

export default withRouter(
    withTranslation()(SectionItemPaymentsConfiguration)
);